import { browserHistory } from 'react-router';
import { invokeApi } from './common'
import { ACTION_TYPE } from '../constants'
import { setDoneSecurity } from './doneSecurity';
import { trans } from '../localization/language'

function FacebookConnectInitedAction(data){
	return {
		'type': 'FACEBOOK_CONNECT_INITED',
		'fb_account': data.fb_account
	}
}

/* async function */
export function initFacebookConnect(token, code){
	return invokeApi(
		'/api/account/facebookConnect/init',
		{
			credentials: 'same-origin',
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				'facebook_token': token,
				'facebook_code': code
			})
		},
		handleFacebookConnectInited
	)
}

export function proceedFacebookConnect(token){
	return invokeApi(
		'/api/account/facebookConnect/proceed',
		{
			credentials: 'same-origin',
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				'facebook_token': token,
			})
		},
		handleFacebookConnectProceeded
	)
}

/* helper function */
function handleFacebookConnectInited(dispatch, data){
	switch(data.next_action.action_type){
		case ACTION_TYPE.PROCEED_FACEBOOK_CONNECT:
			dispatch(FacebookConnectInitedAction(data));
			break;
		default:
			break;
	}
}

function handleFacebookConnectProceeded(dispatch, data){
	let title = trans('connect_facebook_title');
	let message = trans('facebook_connect_successful');

	dispatch(setDoneSecurity(title, message));
	browserHistory.push('/security/done')
}



// WEBPACK FOOTER //
// ./app/actions/facebook.js